module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('accessibility-nav'), _c('div', {
    staticClass: "container hidden-xs hidden-sm"
  }, [_c('div', {
    staticClass: "site-topo"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Index'
      }
    }
  }, [_c('h1', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/logo_desktop.png",
      "title": "Logomarca da PROAD"
    }
  })])]), _c('barra-busca')], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d599c03","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue/layouts/PageHeader.vue
// module id = 454
// module chunks = 0